// functions to scroll into steps

import {COLLAPSE_DURATION_MS} from 'app/utils/constants';

export function scrollIntoNode(nodeId: string, wait = COLLAPSE_DURATION_MS) {
  const elNode = document.getElementById(nodeId);

  if (elNode != null) {
    setTimeout(() => {
      if (isNodeTopVisible(elNode) == false) {
        elNode.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, wait);
  }
}

export function scrollIntoStep(stepId: string): void {
  const stepNode = document.getElementById(stepId);

  if (stepNode != null) {
    /* on step link click */
    location.href = `#${stepId}`;
  }
}

function isNodeTopVisible(elem: HTMLElement): boolean | void {
  const container = document.querySelector('.scrollable-container');

  if (container == null) {
    return;
  }

  const {top: containerTop, height: containerHeight} =
    container.getBoundingClientRect();
  const elementTop = elem.getBoundingClientRect().top;
  return (
    elementTop > containerTop && elementTop < containerTop + containerHeight
  );
}
